import { Icon } from '@iconify/react';
import React, { useEffect, useState } from 'react';
import { pageTitle } from '../../helper';
import Div from '../Div';
import PageHeading from '../PageHeading';
import SectionHeading from '../SectionHeading';
import Spacing from '../Spacing';
import ContactInfoWidget from '../Widget/ContactInfoWidget';

export default function ContactPage() {
  // State variables for form fields
  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [projectType, setProjectType] = useState('');
  const [mobile, setMobile] = useState('');
  const [projectBrief, setProjectBrief] = useState('');
  const [sending, setSending] = useState(false);
  const [sendStatus, setSendStatus] = useState(null);

  pageTitle('Contact Us');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Handle form submission with WhatsApp integration
  const handleSubmit = async (e) => {
    e.preventDefault();
    setSending(true);
    setSendStatus(null);

    // Format the message to include all form information
    const formattedMessage = `Name: ${fullName}\nEmail: ${email}\nProject Type: ${projectType}\nMobile: ${mobile}\nProject Brief: ${projectBrief}`;

    try {
      // Replace with your WhatsApp number
      const whatsappUrl = `https://wa.me/+919501412704?text=${encodeURIComponent(formattedMessage)}`;
      window.open(whatsappUrl, "_blank");

      // Update status and reset form
      setSendStatus("success");
      console.log({ fullName, email, projectType, mobile, projectBrief });

      // Reset form fields after successful submission
      setFullName("");
      setEmail("");
      setProjectType("");
      setMobile("");
      setProjectBrief("");
    } catch (error) {
      console.error("Error sending message:", error);
      setSendStatus("error");
    } finally {
      setSending(false);
    }
  };

  return (
    <>
      <PageHeading
        title="Let's Build the Future Together!"
        bgSrc="/images/contact_hero_bg.jpeg"
        pageLinkText="Contact"
      />
      <Spacing lg="150" md="80" />
      <Div className="container">
        <Div className="row">
          <Div className="col-lg-6">
            <SectionHeading
              title="Got an Idea?<br/> Let's Make It Happen"
              subtitle="Your Next Big Move Starts Here!"
            />
            <Spacing lg="55" md="30" />
            <ContactInfoWidget withIcon />
            <Spacing lg="0" md="50" />
          </Div>
          <Div className="col-lg-6">
            <form className="row" onSubmit={handleSubmit}>
              <Div className="col-sm-6">
                <label className="cs-primary_color">Full Name*</label>
                <input
                  type="text"
                  className="cs-form_field"
                  value={fullName}
                  onChange={(e) => setFullName(e.target.value)}
                  required
                />
                <Spacing lg="20" md="20" />
              </Div>
              <Div className="col-sm-6">
                <label className="cs-primary_color">Email*</label>
                <input
                  type="email"
                  className="cs-form_field"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
                <Spacing lg="20" md="20" />
              </Div>
              <Div className="col-sm-6">
                <label className="cs-primary_color">Project Type*</label>
                <input
                  type="text"
                  className="cs-form_field"
                  value={projectType}
                  onChange={(e) => setProjectType(e.target.value)}
                  required
                />
                <Spacing lg="20" md="20" />
              </Div>
              <Div className="col-sm-6">
                <label className="cs-primary_color">Mobile*</label>
                <input
                  type="tel"
                  className="cs-form_field"
                  value={mobile}
                  onChange={(e) => setMobile(e.target.value)}
                  required
                />
                <Spacing lg="20" md="20" />
              </Div>
              <Div className="col-sm-12">
                <label className="cs-primary_color">Project Brief*</label>
                <textarea
                  cols="30"
                  rows="7"
                  className="cs-form_field"
                  value={projectBrief}
                  onChange={(e) => setProjectBrief(e.target.value)}
                  required
                ></textarea>
                <Spacing lg="25" md="25" />
              </Div>
              <Div className="col-sm-12">
                <button
                  className="cs-btn cs-style1"
                  type="submit"
                  disabled={sending}
                  style={{
                    opacity: sending ? 0.7 : 1,
                    cursor: sending ? "not-allowed" : "pointer"
                  }}
                >
                  <span>{sending ? "Sending..." : "Send Message"}</span>
                  <Icon icon="bi:arrow-right" />
                </button>

                {sendStatus && (
                  <Div style={{
                    marginTop: "15px",
                    padding: "10px",
                    borderRadius: "4px",
                    textAlign: "center",
                    backgroundColor: sendStatus === "success" ? "rgba(0, 128, 0, 0.2)" : "rgba(255, 0, 0, 0.2)",
                    color: sendStatus === "success" ? "#4ade80" : "#f87171"
                  }}>
                    {sendStatus === "success"
                      ? "Message sent successfully! Redirecting to WhatsApp..."
                      : "Failed to send message. Please try again."}
                  </Div>
                )}
              </Div>
            </form>
          </Div>
        </Div>
      </Div>
      <Spacing lg="150" md="80" />
      <Div className="cs-google_map">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1751.9160866700206!2d77.32855775188729!3d28.57480189695622!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce58377693bbf%3A0x946c2aa18d809e9e!2sJust%20Charge!5e0!3m2!1sen!2sin!4v1742797775692!5m2!1sen!2sin"
          allowFullScreen
          title="Google Map"
        />
      </Div>
      <Spacing lg="50" md="40" />
    </>
  );
}
